import React from "react";
import { Modal } from "react-bootstrap";

const CatalogueCustomizationModal = ({
  show,
  onHide,
  customizationSets,
  selectedCustomizations,
  setSelectedCustomizations,
  onApply,
}) => {
  const handleToggle = (field) => {
    setSelectedCustomizations((prev) =>
      prev.includes(field)
        ? prev.filter((f) => f !== field)
        : [...prev, field]
    );
  };

  if (!show) return null;

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      size="lg"
      backdrop="static"
      keyboard={false}
    >
      {/* HEADER */}
      <Modal.Header
        closeButton
        className="border-0 text-white py-3 rounded-top"
        style={{ backgroundColor: "rgba(1, 195, 125, 1)" }}
      >
        <Modal.Title className="fw-bold fs-5 d-flex align-items-center gap-2">
          <i className="bi bi-sliders2-vertical fs-4"></i> Customize Category
        </Modal.Title>
      </Modal.Header>

      {/* BODY */}
      <Modal.Body className="bg-light px-4 py-3">
        <p className="text-muted mb-4">
          Select customization preferences to define how this category behaves in
          orders. You can predefine options such as sweetness, spice, and more.
        </p>

        <div className="row g-3">
          {customizationSets.map((set, index) => {
            const isChecked = selectedCustomizations.includes(
              set.customize_field
            );

            return (
              <div key={index} className="col-md-6">
                <div
                  onClick={() => handleToggle(set.customize_field)}
                  className={`border rounded-4 p-3 shadow-sm h-100 transition-all position-relative ${
                    isChecked ? "bg-white shadow border-2" : "bg-white border-0"
                  }`}
                  style={{
                    transition: "0.2s all ease-in-out",
                    cursor: "pointer",
                    borderColor: isChecked
                      ? "rgba(1, 195, 125, 1)"
                      : undefined,
                  }}
                >
                  {/* Top Row */}
                  <div className="d-flex align-items-start justify-content-between">
                    <div className="d-flex align-items-center gap-2">
                      <input
                        className="form-check-input mt-0 cursor-pointer"
                        type="checkbox"
                        id={`set-${index}`}
                        checked={isChecked}
                        readOnly
                      />
                      <label
                        htmlFor={`set-${index}`}
                        className="form-check-label fw-semibold mb-0 user-select-none"
                        onClick={(e) => e.stopPropagation()}
                      >
                        {set.customize_field}
                      </label>
                    </div>

                    {/* Selected checkmark icon */}
                    {isChecked && (
                      <span
                        className="position-absolute top-0 end-0 m-2"
                        style={{
                          fontSize: "1.2rem",
                          color: "rgba(1, 195, 125, 1)",
                        }}
                      >
                        <i className="bi bi-check-circle-fill"></i>
                      </span>
                    )}
                  </div>

                  {/* Option Pills */}
                  <div className="d-flex flex-wrap gap-2 mt-3">
                    {set.options.map((opt) => (
                      <div
                        key={opt}
                        className="px-3 py-1 rounded-pill border small"
                        style={{
                          transition: "0.2s ease",
                          fontWeight: 500,
                          backgroundColor: isChecked
                            ? "rgba(1, 195, 125, 1)"
                            : "#f8f9fa",
                          color: isChecked ? "white" : "#6c757d",
                          borderColor: isChecked
                            ? "rgba(1, 195, 125, 1)"
                            : "#dee2e6",
                        }}
                      >
                        {opt}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </Modal.Body>

      {/* FOOTER */}
      <Modal.Footer className="border-0 d-flex justify-content-between px-4 py-3 bg-white rounded-bottom">
        <button
          className="btn px-4 py-2 rounded-pill"
          style={{
            borderColor: "rgba(1, 195, 125, 1)",
            color: "rgba(1, 195, 125, 1)",
          }}
          onClick={onHide}
        >
          Close
        </button>

        <button
          className="btn px-4 py-2 rounded-pill fw-semibold shadow-sm"
          style={{
            backgroundColor: "rgba(1, 195, 125, 1)",
            borderColor: "rgba(1, 195, 125, 1)",
            color: "white",
          }}
          onClick={onApply}
        >
          <i className="bi bi-check2-circle me-2"></i> Apply Customization
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default CatalogueCustomizationModal;
